import React, {useEffect, useState} from 'react';
import { Divider, TextField } from '@mui/material';
import OrgCard from '../dashboard_components/orgs/OrgCard';
import AddCardIcon from '@mui/icons-material/AddCard';
import OrgModal from '../dashboard_components/orgs/OrgModal';
import useAxiosProtect from '../../../hooks/useAxiosProtect';
import { isMobile } from 'react-device-detect';

import {TableHead, TableRow, Table, TableBody, TableCell, TableContainer} from '@mui/material';
import Paper from '@mui/material/Paper';

// the client main page
const StaffDashContainer = props => {
    const axiosProtect = useAxiosProtect();
    
    //state vars
    const [orgs, setOrgs] = useState([]);
    const [orgModalState, setOrgModalState] = useState(undefined)

    const [esUsers, setESUsers] = useState([]);
    const [selectedESUser, setSelectedESUser] = useState('');

    // modal - delete client
    const [delClient, setDelClient] = useState('');

    const [queryString, setQueryString] = useState('');    
    

    const addClientCard = client => {
        setOrgs([...orgs, client])
    }

    const removeClientCard = name => {
        let tempArray = [...orgs];

        for(let i = 0;i<tempArray.length;++i){
            if(tempArray[i].name === name){
                tempArray.splice(i, 1);
                break;
            }
        }

        setOrgs(tempArray)
    }

    useEffect(() => {
       const controller = new AbortController();

       const getOrgs = async () => {
            try{
                const response = await axiosProtect.get('/auth/org/list', {
                    signal:  controller.signal
                });

                setOrgs([...response.data.orgs])
            }catch(err) {
                console.log(err)
            }
       }

       const getUsers = async () => {
        try{
            const response = await axiosProtect.get('/auth/query/es-users', {
                signal:  controller.signal
            });

            let users = [...response.data];
            users.sort((a, b) => a.first_name.localeCompare(b.first_name));

            setSelectedESUser(users[0]._id)
            setESUsers(users);
        }catch(err) {
            console.log(err)
        }
   }

       getOrgs();
       getUsers();

    }, []);

    const toggleModalState = newState => {
        setOrgModalState(newState)
    }

    const updateDelClient = (name, id) => {
        setDelClient({
            name,
            id
        })
    }


    return(
        <div style={{padding:'2%', backgroundColor:'#f5f5f5', minHeight:'95vh'}}>
            <OrgModal orgModalState={orgModalState} toggleModalState={toggleModalState} 
                delClient={delClient} addClientCard={addClientCard} removeClientCard={removeClientCard}
                esUsers={esUsers} selectedESUser={selectedESUser} setSelectedESUser={setSelectedESUser}
            />

           <div id='es-sites' style={{ width: '100%' }}>
                <TableContainer component={Paper} sx={{ width: '100%' }}>
                    <Table aria-label="collapsible table">
                        <TableHead style={{ backgroundColor:'rgb(3,117,176)' }}>
                            <TableRow>
                                <TableCell colSpan={7} style={{color:'whitesmoke', padding:'0.9rem 0.75rem'}}>
                                    <div style={{display:'flex', flexDirection:'row'}}>
                                        <h4 style={{ color:'whitesmoke', margin:'0', flex:'3', display:'flex', alignItems:'center', gap:'0.4rem' }}>
                                            Client manager
                                            <AddCardIcon
                                                style={{ color: '#f5f5f5', cursor: 'pointer',fontSize: 32}}
                                                onClick={() => toggleModalState('add')}
                                            />
                                        </h4>
                                
                                        <TextField
                                            sx={{flex: 2,
                                                "& .MuiInputLabel-root": { color: "white" },
                                                "& .MuiInputLabel-root.Mui-focused": { color: "white" },
                                                "& .MuiOutlinedInput-root": {color: "white",
                                                    "& fieldset": { borderColor: "white" },
                                                    "&:hover fieldset": { borderColor: "white" },
                                                    "&.Mui-focused fieldset": { borderColor: "white" }},
                                                "& .MuiInputBase-input::placeholder": { color: "white", opacity: 1 }}}
                                            label="Search"
                                            fullWidth
                                            value={queryString}
                                            onChange={e => setQueryString(e.target.value)}
                                            inputProps={{autoComplete: 'off'}}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                    </Table>
                </TableContainer>
                <Divider style={{margin:'0.5vh 0 1vh 0'}} />
                
                <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem', width: '100%'}} >
                    {[...orgs]
                        .filter(org =>
                            org.name?.toLowerCase().includes(queryString.toLowerCase())
                        )
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((org) => (
                            <OrgCard
                                key={org._id} name={org.name} id={org._id}
                                hq_city={org.hq_city} hq_state={org.hq_state} hq_country={org.hq_country}
                                industry={org.industry} sites={org.sites}
                                toggleModalState={toggleModalState}
                                updateDelClient={updateDelClient}
                            />
                        ))}
                </div>
            </div>
            <br/>
        </div>
    )
}

export default StaffDashContainer;